export const MAX_IMAGE_UPLOAD_BYTES = Math.floor(4.5 * 1024 * 1024);
export const MAX_CERTIFICATE_UPLOAD_BYTES = 4 * 1024 * 1024;

const CERTIFICATE_IMAGE_TYPES = new Set(['image/jpeg', 'image/png']);

export const isImageSizeAllowed = (
  file: File,
  maxBytes: number = MAX_IMAGE_UPLOAD_BYTES,
): boolean => file.size <= maxBytes;

export const isCertificateImageFile = (file: File): boolean => {
  if (CERTIFICATE_IMAGE_TYPES.has(file.type)) return true;
  const ext = file.name.split('.').pop()?.toLowerCase();
  return ext === 'jpg' || ext === 'jpeg' || ext === 'png';
};
